import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, filter } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { DebtAnalysisWidgetConfiguration } from '../models/debt-analysis-widget-configuration.model';
import * as actions from '../actions/debt-analysis-widget-configuration.actions';
import * as selectors from '../selectors/debt-analysis-widget-configuration.selectors';

@Injectable()
export class DebtAnalysisWidgetConfigurationService {

  constructor(
    private readonly store: Store<ApplicationState>) { }

  getConfig(debtAnalysisWidgetConfigurationId: number): Observable<DebtAnalysisWidgetConfiguration> {
    return this
      .store
      .pipe(select(selectors.selectDebtAnalysisWidgetConfiguration(debtAnalysisWidgetConfigurationId)),
        tap((config: DebtAnalysisWidgetConfiguration) => {
          if (!config) {
            this.store.dispatch(new actions.LoadAll(new actions.DebtAnalysisWidgetConfigsActionPayload()));
          }
        })
      );
  }

}
